import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Input, Checkbox, CheckboxGroup } from 'rsuite'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import { isRequired, isValidators } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'

export default function CheckboxColForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  ...props
}) {
  const [checkAll, setCheckAll] = useState(false)
  const [disableAll, setDisableAll] = useState(
    schema.disabledAllCheckbox && schema.disabledAllCheckbox.value
  )

  const column = props.column ? props.column : 1
  const [checkBoxList, setCheckBoxList] = useState([])
  const [indeterminateSelectALL, setIndeterminateSelectALL] = useState()
  const [isDisabledInputOther, setIsDisabledInputOther] = useState(!schema?.inputOther?.isSelected)
  const disabled = props.disabled
  const OTHER = 'OTHER'

  const options = schema.options
    ? schema.options.map((item) => {
        return item.value
      })
    : []

  useEffect(() => {
    if (Array.isArray(schema.optionSelected) && schema.optionSelected.length > 0) {
      handleChange(schema.optionSelected)
      setCheckBoxList(schema.optionSelected)
      setValue(schema.name, schema.optionSelected)
    } else {
      setValue(schema.name)
    }

    schema.inputOther && setValue(schema.inputOther.name, schema.inputOther.value)
  }, [schema])

  const handleDisbleAll = (_, checked) => {
    if (checked) {
      if (schema.inputOther) {
        setValue(schema.inputOther.name, '')
        clearErrors(schema.inputOther.name)
        setIsDisabledInputOther(true)
      }

      setValue(schema.name, [])
      setValue('disabledAll', true)
      clearErrors(schema.name)
      setCheckBoxList([])
    } else {
      setValue('disabledAll', false)
    }

    setDisableAll(checked)
  }

  const handleCheckAll = (_, checked) => {
    const nextValue = checked ? options : []

    // console.log('checked', checked, 'nextValue', nextValue)
    setCheckBoxList(nextValue)
    setValue(schema.name, nextValue)
    setIndeterminateSelectALL(
      nextValue.length > 0 && nextValue.length != options.length //|| isDisabledInputOther
    )

    if (isRequired(schema.validators) && nextValue.length === 0) {
      setValue(schema.name)
    }

    if (schema.inputOther) {
      if (nextValue.length == 0) {
        setValue(schema.inputOther.name, '')
        clearErrors(schema.inputOther.name)
        setIsDisabledInputOther(true)
      }
      // else {
      //   setIsDisabledInputOther(false)
      // }
    }

    setCheckAll(checked)
  }

  const handleChange = (optionSelected) => {
    if (isRequired(schema.validators) && optionSelected.length === 0 && isDisabledInputOther) {
      setValue(schema.name)
    } else {
      if (!isDisabledInputOther && !optionSelected?.some((e) => e === OTHER)) {
        optionSelected.push(OTHER)
      }
      setValue(schema.name, optionSelected)
    }

    setCheckBoxList(optionSelected)
    setIndeterminateSelectALL(
      optionSelected.length > 0 && optionSelected.length != options.length //|| !isDisabledInputOther
    )
    setCheckAll(optionSelected.length === options.length)
  }

  const onSelectOther = (checked) => {
    let select = getValues(schema.name)
    setIndeterminateSelectALL((select?.length > 0 && select?.length != options.length) || checked)
    setCheckAll(select?.length === options.length || !checked)
    if (!checked) {
      setValue(schema.inputOther.name)
      clearErrors(schema.inputOther.name)

      const index = select?.indexOf(OTHER)
      if (index > -1) {
        select.splice(index, 1)
        setValue(schema.name, select)
      }
    } else if (!select?.some((e) => e === OTHER)) {
      select ? select.push(OTHER) : (select = [OTHER])
      setValue(schema.name, select)
    }
    setIsDisabledInputOther(!checked)
  }

  const generateColItem = (options, start, end, col) => {
    return (
      <Col xs={24} sm={24} md={Math.floor(24 / col)} lg={Math.floor(24 / col)}>
        {options.map((item, index) => {
          if (index >= start && index <= end) {
            return (
              <Checkbox value={item.value} disabled={disableAll || disabled}>
                {item.label}
              </Checkbox>
            )
          }
        })}
      </Col>
    )
  }

  const generateCheckboxList = (options, column) => {
    if (options) {
      column = column ? column : 1
      const perColumn = Math.ceil(options.length / column)

      let result = []

      for (let index = 0; index < column; index++) {
        let start = index * perColumn
        let end = (index + 1) * perColumn - 1

        result[index] = generateColItem(options, start, end, column)
      }

      return (
        <Row>
          {result.map((item) => {
            return item
          })}
        </Row>
      )
    }
  }

  return (
    <div>
      <Form>
        {schema.disabledAllCheckbox && (
          <Controller
            key={'disabledAll'}
            name={'disabledAll'}
            control={control}
            // rules={isValidators(schema.validators)}
            defaultValue={schema.disabledAllCheckbox.value}
            render={(props) => {
              return (
                <Checkbox onChange={handleDisbleAll} checked={disableAll} value={props.value}>
                  {schema.disabledAllCheckbox.label}
                </Checkbox>
              )
            }}
          />
        )}

        <ErrorMessage error={errors[schema.name]} />
        {schema.alert && <CustomIconMessageInfo content={schema.alert} />}

        {schema.selectAllCheckbox && (
          <>
            {/* {console.log('indeterminateSelectALL = ', indeterminateSelectALL)} */}
            <Checkbox
              onChange={handleCheckAll}
              indeterminate={indeterminateSelectALL}
              checked={checkAll}
              disabled={disableAll}
            >
              เลือกทั้งหมด
            </Checkbox>
            <hr />
          </>
        )}

        <Controller
          key={schema.name}
          name={schema.name}
          control={control}
          rules={!disableAll && isValidators(schema.validators)}
          defaultValue={checkBoxList}
          render={(props) => {
            return (
              <CheckboxGroup value={checkBoxList} onChange={handleChange}>
                {generateCheckboxList(schema.options, column)}
              </CheckboxGroup>
            )
          }}
        />

        {schema.inputOther?.enable && (
          <>
            <Checkbox
              disabled={disableAll}
              checked={!isDisabledInputOther}
              onChange={(_, checked, e) => {
                onSelectOther(checked)
              }}
            >
              {schema.inputOther.label}
            </Checkbox>

            <Row style={{ paddingLeft: 35, marginBottom: 10 }}>
              <ErrorMessage error={errors[schema.inputOther.name]}></ErrorMessage>
            </Row>
            <Input
              style={{ width: 'calc(100% - 35px)', marginLeft: 35 }}
              name={schema.inputOther.name}
              placeholder={schema.inputOther.label}
              defaultValue={schema.inputOther.value}
              disabled={isDisabledInputOther}
              inputRef={register({
                required: isDisabledInputOther
                  ? false
                  : `กรุณากรอกข้อมูล อื่นๆ${schema.inputOther.label}`,
              })}
            />
          </>
        )}
      </Form>
    </div>
  )
}
